var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassPasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 104,
    viewBox: "0 0 69 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4E443D",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 31.5 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 62,
    x: 6,
    strokeWidth: 7,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 6,
    d: "M26,31.7886364 L88,31.7886364 L26,31.7886364 Z",
    transform: "rotate(-90 57 31.789)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 6,
    d: "M62.5,30.2886364 L101.5,30.2886364 L62.5,30.2886364 Z",
    transform: "rotate(-90 82 30.289)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 6,
    d: "M51.5,30.2886364 L90.5,30.2886364 L51.5,30.2886364 Z",
    transform: "rotate(-90 71 30.289)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    x2: 16.535,
    y1: 30,
    y2: 30,
    strokeLinejoin: "round",
    strokeWidth: 6,
    transform: "rotate(-90 2.268 31.289)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 6,
    transform: "translate(17 22.289)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.2873563 19.6749345L25.2873563.19036096M5.64597701.19036096L5.64597701 19.6749345M30.743295 14.2625529L30.743295 5.60274249M.190038314 5.60274249L.190038314 14.2625529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97203065,9.96632386 L22.9613027,9.96632386 L7.97203065,9.96632386 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassPasses);
export default __webpack_public_path__ + "static/media/class-passes.9d00f45fe8beaddf822770ff994b7190.svg";
export { ForwardRef as ReactComponent };